import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { ErrorMessage as ErrorMessageComponent } from 'formik'
import { isEmpty } from 'lodash-es'

// Components

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
const propTypes = {
  name: PropTypes.string,
  customError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  wrapperClassName: PropTypes.string,
}

const defaultProps = {
  onChange: () => {},
}

const ErrorMessage = React.memo((props) => {
  const { name, customError, wrapperClassName } = props

  const hasCustomError = !isEmpty(customError)

  return hasCustomError ? (
    <div className={cx('error-message')}>
      <div className={cx('error-message__border', wrapperClassName)} />
      <div className={cx('error-message__text')}>{customError}</div>
    </div>
  ) : (
    <ErrorMessageComponent name={name}>
      {(message) => {
        return (
          <div className={cx('error-message')}>
            <div className={cx('error-message__border', wrapperClassName)} />
            <div className={cx('error-message__text')}>{message}</div>
          </div>
        )
      }}
    </ErrorMessageComponent>
  )
})

ErrorMessage.propTypes = propTypes
ErrorMessage.defaultProps = defaultProps

export default ErrorMessage
